import React from 'react';
import { SERVICE_ICONS, ServiceIcon } from '../../constants/serviceIcons';
import { useLanguage } from '../../context/LanguageContext';

export default function IconPicker({ value, onChange }) {
  const { t } = useLanguage();
  const entries = Object.entries(SERVICE_ICONS);

  return (
    <div>
      <label className="form-label">{t.admin.services.icon || 'Icon'}</label>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '8px',
        padding: '12px',
        background: '#0C1220',
        border: '1px solid rgba(148,163,184,0.2)',
        borderRadius: '6px',
        maxHeight: '280px',
        overflowY: 'auto'
      }}>
        {entries.map(([key, icon]) => (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            title={icon.label}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              padding: '8px 4px',
              background: value === key ? 'rgba(212,43,43,0.15)' : 'transparent',
              border: value === key ? '2px solid #D42B2B' : '1px solid rgba(148,163,184,0.15)',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.15s'
            }}
          >
            <ServiceIcon iconKey={key} size={24} color={value === key ? '#D42B2B' : '#94A3B8'} />
            <span style={{
              fontSize: '0.55rem',
              color: value === key ? '#D42B2B' : '#64748B',
              textAlign: 'center',
              lineHeight: 1.2,
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {icon.label}
            </span>
          </button>
        ))}
      </div>
      {!value && (
        <div className="form-text">{t.admin.services.selectIcon || 'Select an icon for this service'}</div>
      )}
    </div>
  );
}
